import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

function Cable() {
  return (
    <section className="service-detail">

      {/* 🔥 HERO BANNER */}
        <section className="hero-banner">
          <img src="/service/UndergroundCabling.png" alt="" />

          <div className="hero-content">
            <h1>UNDERGROUNG CABLING</h1>
            {/* <p>Swastika Infra Limited</p>   */}
          </div>
        </section>


      {/* 📄 CONTENT SECTION */}
        <div className="service-detail-content">

          <h2 className="service-heading">UNDERGROUNG CABLING</h2>

          <p>
           Advanced underground cabling solutions deliver safer, more reliable and efficient power distribution using modern trenchless technology. Designed for urban environments, these systems minimize surface disruption, enhance city aesthetics and ensure durable, future-ready electrical infrastructure.
          </p>

         

         

          {/* <h3 className="highlight-title">Key Highlights:</h3>

          <ul className="highlight-list">
            <li>Redevelopment of high-traffic railway stations</li>
            <li>Construction and upgrading of tracks and rail infrastructure</li>
            <li>Integration of advanced technologies for faster execution</li>
            <li>Alignment with modernization and smart mobility goals</li>
          </ul> */}


              <Link to="/service" className="back-btn">
                ← Back 
              </Link> 
        </div>

    </section>
  );
}

export default Cable;
